/**
 * №14.1 (D-DS3) / №14.1.1-C — the Ghost-Grid K brand mark, ONE source.
 *
 * A 3×3 grid: six filled blocks tracing a K, three ghost blocks holding the grid
 * silhouette. The geometry byte-matches the supplied asset
 * `branding/icons/concept-b-ghost-grid/kuvio-ghost-icon-64.svg` (same rects, same
 * `rx`) — R2: assets are supplied, never drawn.
 *
 * Rendered MONOCHROME in the shell accent (`.brand__mark .kf/.kg` fill
 * `var(--accent)` at faceted opacities), so the one mark configures per vertical:
 * Kuvio Legal is the green configuration, ink/chancery recolour for free.
 *
 * Was a private helper inside `AppShellLayout`; extracted at 14.1.1-C so the
 * login/OTP surface renders the same mark from the same place instead of the
 * multicolour Pattern-Blocks icon it had been showing.
 */
export function GhostGridK({ size = 26 }: { size?: number }) {
  return (
    <svg className="brand__mark" viewBox="0 0 64 64" width={size} height={size} aria-label="Kuvio">
      <rect className="kf" x={2} y={2} width={18} height={18} rx={3.5} />
      <rect className="kg" x={23} y={2} width={18} height={18} rx={3.5} />
      <rect className="kf f3" x={44} y={2} width={18} height={18} rx={3.5} />
      <rect className="kf f2" x={2} y={23} width={18} height={18} rx={3.5} />
      <rect className="kf f3" x={23} y={23} width={18} height={18} rx={3.5} />
      <rect className="kg" x={44} y={23} width={18} height={18} rx={3.5} />
      <rect className="kf f2" x={2} y={44} width={18} height={18} rx={3.5} />
      <rect className="kg" x={23} y={44} width={18} height={18} rx={3.5} />
      <rect className="kf" x={44} y={44} width={18} height={18} rx={3.5} />
    </svg>
  );
}
